import React from 'react';
import { useIntl } from 'react-intl';

import { Box, Button, Flex, Icons } from 'baukasten';

import { useAiCompanionSidebar } from './AiCompanionSidebarContext';
import { CompanionHeaderActions } from './components/CompanionHeaderActions';
import messages from './messages';

export const AiCompanionSidebarHeader = () => {
  const { formatMessage } = useIntl();
  const { mode, toggleMode, close } = useAiCompanionSidebar();

  const ExpandIcon =
    mode === 'sidebar' ? Icons.SolidChevronLeft : Icons.SolidChevronRight;
  const expandLabel =
    mode === 'sidebar'
      ? formatMessage(messages.expandToFullscreen)
      : formatMessage(messages.collapseToSidebar);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      py={2}
      px={3}
      backgroundColor="grey-light-50"
      borderPosition={['bottom']}
      borderColor="grey-light-100"
      minHeight="40px"
    >
      <Flex alignItems="center">
        <Button
          variant="text"
          onClick={toggleMode}
          startIcon={ExpandIcon}
          aria-label={expandLabel}
        />
        <CompanionHeaderActions />
      </Flex>
      <Button
        variant="text"
        onClick={close}
        startIcon={Icons.Close}
        aria-label={formatMessage(messages.closeCompanion)}
      />
    </Box>
  );
};
